import React from 'react';
import { TColorRole, colorMap } from '../../../types/types';
import { hexToRgb } from '../../../utils/hexToRgb';

interface IPanelProps {
    children?: React.ReactNode;
    animation?: boolean;
    color?: TColorRole;
    colorBorder?: TColorRole;
    borderIntensity?: number;
    colorIntensity?: number;
    hasShadow?: boolean;
    stretch?: boolean;
    borderWidth?: number;
    isBlock?: boolean;
    isRelative?: boolean;
    radius?: 's' | 'm' | 'l' | 'xl' | 'full' | 'none';
    bigShadow?: boolean;
    animareOutline?: boolean;
}

export const PanelLayout: React.FC<IPanelProps> = ({
    children,
    animation = false,
    color = 'white',
    colorBorder = 'dark',
    borderIntensity = 0.2,
    borderWidth = 1,
    colorIntensity = 1,
    hasShadow = true,
    stretch = false,
    isBlock = false,
    isRelative = false,
    radius = 'm',
    bigShadow = false,
    animareOutline = false
}) => {
    const hexColor = colorMap[color] || colorMap['white'];
    const hexColorBorder = colorMap[colorBorder] || colorMap['grey-normal'];
    const { r: rc, g: gc, b: bc } = hexToRgb(hexColor);
    const { r, g, b } = hexToRgb(hexColorBorder);

    return (
        <div
            className={`panel ${animareOutline && 'panel__outline'} panel__radius--${radius} ${isRelative && 'panel__relative'} ${isBlock && 'panel__block'} ${stretch && 'panel__stretch'} ${hasShadow && 'panel__shadow'} ${bigShadow && 'panel__shadow-xxl'} ${animation ? 'animation' : ''}`}
            style={{ backgroundColor: `rgba(${rc}, ${gc}, ${bc}, ${colorIntensity})`, border: `${borderWidth}px solid rgba(${r}, ${g}, ${b}, ${borderIntensity})` }}
        >
            {children}
        </div>
    );
};
